<template>
  <QuestionBody :qsNumber="qsNumber" :nextPage="nextPage" :navigateType="navigateType" :content="content" />
</template>

<script>
import QuestionBody from '@/layout/QuestionBody.vue'
export default {
  name: "Qs2-08",
  components: {
    QuestionBody
  },
  data() {
    return {
      qsNumber: 28,
      navigateType: 'CLICK_NEXT',
      content: {
        componentsType: {
          pc: 'normalBtn',
          mobile: 'longBtn'
        },
        titleIcon: require('@/assets/icon/questionIcon/21-Digestion.png'),
        mainTitle: 'Do you have any of the following intestinal problems?',
        subTitle: 'Select all that apply.',
        btn: [
          [
            {
              text: 'Bloating',
            },{
              text: 'Constipation',
            },{
              text: 'Diarrhea',
            }
          ]
        ],
        hasInput: true
      }
    }
  },
  computed: {
    nextPage: function(){
      if(this.$store.state.qsData[21] && this.$store.state.qsData[21].answer.length>0){
        if(this.$store.state.qsData[21].answer.indexOf('Skin') !== -1){
          return '/questionnaire/section2/9'
        }else if(this.$store.state.qsData[21].answer.indexOf('Hair') !== -1){
          return '/questionnaire/section2/11'
        }else if(this.$store.state.qsData[21].answer.indexOf('Emotion') !== -1){
          return '/questionnaire/section2/13'
        }else if(this.$store.state.qsData[21].answer.indexOf('Menstrual problems') !== -1){
          return '/questionnaire/section2/16'
        }else if(this.$store.state.qsData[21].answer.indexOf('Women\'s Health') !== -1){
          return '/questionnaire/section2/18'
        }else{
          return '/questionnaire/section3'
        }
      }else{
        return '/questionnaire/section3'
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
</style>
